import React, { useState } from "react";
import { Modal } from "antd";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import styles from "./bottomBar.module.scss";
import { mixPanelToken, isStage } from "../../../config";

const SOS_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/sos_1790565975941.svg";
const SOS_RAISED_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/SOSRaised.svg";
const PHONE_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/callMarshal_1790565975941.svg";

const MARSHAL_NUMBER = "+91-8287009889";

const BottomBar = props => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { booking, inventory_type, showSOS, onEmergency } = props;

  const isSOSRaised = booking.isSOSAlertInserted;

  const callMarshal = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Call Marshal", {
      crew_assigned: !!booking.trip.busHostId,
      inventory: "ZINGBUS",
      inventory_type,
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      departure_time: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      view_from: "Self Help Page",
      service_name: booking.trip.service.name
    });

    if (booking.boardingPoint.time - 3 * 60 * 60 * 1000 < Date.now()) {
      window.open(`tel:${MARSHAL_NUMBER}`);
      window.location.href = `tel:${MARSHAL_NUMBER}`;
    } else {
      setIsModalVisible(true);
    }
  };

  return (
    <>
      <div className={styles.bottomBar}>
        {showSOS ? (
          <>
            <div
              className={styles.action}
              onClick={isSOSRaised ? null : onEmergency}
            >
              <img src={isSOSRaised ? SOS_RAISED_ICON : SOS_ICON} alt="" />
              <span>{isSOSRaised ? "SOS Raised" : "Emergency"}</span>
            </div>
            <div className={styles.divider} />
          </>
        ) : null}
        <div className={styles.action} onClick={callMarshal}>
          <img src={PHONE_ICON} alt="" />
          <span>Call Marshal</span>
        </div>
      </div>
      <Modal
        centered
        width={"80%"}
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{
          style: {
            background: "#7b2bff",
            right: "40%",
            border: "none"
          }
        }}
      >
        <p
          style={{
            fontSize: "14px",
            fontFamily: "SFProText",
            textAlign: "center",
            fontWeight: "400"
          }}
        >
          Hey, {booking.name}! Our Marshal&apos;s contact Number will be active
          at{" "}
          {moment(booking.boardingPoint.time - 3 * 60 * 60 * 1000).format(
            "Do MMMM YYYY, h:mm:ss a"
          )}
        </p>
      </Modal>
    </>
  );
};

export default BottomBar;
